import './styles.sass';

import React from 'react';
import { NavLink } from 'react-router-dom';

import withFeatureFlags from 'components/Flipper/withFeatureFlags';
import * as QueryParams from 'components/Explorer/models/query_params';
import useQueryParams from 'hooks/useQueryParams';

const tabs = [
  'currents',
  'highlights',
  'outputs',
  'timeline',
  'demographics',
  'mentions',
  'mention_sources',
  'journals'
];

const TabBar = ({ featureFlags }) => {
  const params = useQueryParams();

  return (
    <nav className="Explorer-TabBar" aria-label={I18n.t('Explorer.accessibility.TabBar')}>
      {tabs
        .filter((tab) => tab != 'currents' || featureFlags?.includes('currents'))
        .map((tab) => (
          <NavLink
            key={tab}
            to={QueryParams.locationFor(params, `/${tab}`)}
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            {I18n.t(tab, { scope: 'Explorer.TabBar' })}
          </NavLink>
        ))}
    </nav>
  );
};

export default withFeatureFlags(TabBar);
